import React, { memo, useCallback } from "react";
import { shallowEqual } from "react-redux";
import { useAppDispatch, useAppSelector } from "stores";
import store from "stores/interfaces";

import MyCharacterListItem from "../MyCharacterListItem";
import SortableList from "containers/SortableList";
import SortableItem from "containers/SortableItem";
import { DropProps } from "stores/modules/firestoreModuleUtils/ordaring";
import { reorderMyRoomCharacters } from "stores/modules/entities.room.characters/operations";
import { List } from "@mui/material";

const MyCharacterList = () => {
  const characterIds = useAppSelector(
    store.getSortedMyRoomCharacterIds,
    shallowEqual
  );
  const dispatch = useAppDispatch();

  const onReorder = useCallback(
    (order: DropProps) => {
      dispatch(reorderMyRoomCharacters(order));
    },
    [dispatch]
  );
  return (
    <List>
      <SortableList
        ids={characterIds}
        sortableItem={(id) => (
          <SortableItem id={id}>
            <MyCharacterListItem characterId={id} />
          </SortableItem>
        )}
        onReorder={onReorder}
      />
    </List>
  );
};

export default memo(MyCharacterList);
